import { render, staticRenderFns } from "./active.vue?vue&type=template&id=2c298c48&scoped=true"
import script from "./active.vue?vue&type=script&lang=js"
export * from "./active.vue?vue&type=script&lang=js"
import style0 from "./active.vue?vue&type=style&index=0&id=2c298c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c298c48",
  null
  
)

export default component.exports